import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';

// Participant pages
import WelcomePage from './pages/participant/WelcomePage';
import InterviewPage from './pages/participant/InterviewPage';
import CompletionPage from './pages/participant/CompletionPage';

// Admin pages
import DashboardPage from './pages/admin/DashboardPage';
import AgentBuilderPage from './pages/admin/AgentBuilderPage';
import ResultsPage from './pages/admin/ResultsPage';
import ParticipantDetailPage from './pages/admin/ParticipantDetailPage';
import InsightsPage from './pages/admin/InsightsPage';

import './styles/globals.css';

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          {/* Participant routes */}
          <Route path="/interview/:agentId" element={<WelcomePage />} />
          <Route path="/interview/:agentId/chat" element={<InterviewPage />} />
          <Route path="/interview/:agentId/done" element={<CompletionPage />} />

          {/* Admin routes */}
          <Route path="/admin" element={<DashboardPage />} />
          <Route path="/admin/agents/new" element={<AgentBuilderPage />} />
          <Route path="/admin/agents/:agentId/edit" element={<AgentBuilderPage />} />
          <Route path="/admin/results" element={<ResultsPage />} />
          <Route path="/admin/results/:sessionId" element={<ParticipantDetailPage />} />
          <Route path="/admin/insights" element={<InsightsPage />} />

          {/* Default */}
          <Route path="/" element={<Navigate to="/admin" replace />} />
          <Route path="/interview" element={<Navigate to="/admin" replace />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}
